import React, {useEffect, useRef, useState} from 'react';
import '../FactionSkinRewardModal/FactionSkinRewardModal.css';
import './RankSkinRewardModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {getFactionConfig} from '../../../utils/factions/getFactionConfig';
import {getFactionRankImagePath} from '../../../utils/factions/getFactionRankImagePath';
import {parseRankSkinId, RANK_SKIN_DISPLAY} from '../../../utils/factions/getFactionRankSkinTitle';
import {RANK_NAME_COLORS} from '../../../constants/factions';
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'RankSkinRewardModal';

/**
 * Модалка полученного за матч рангового образа (награда высших лиг, см.
 * calculateRankSkinRewards на сервере). Построена на классах модалки скина из
 * сундука (FactionSkinRewardModal) — та же композиция и анимация появления,
 * отличается подсветкой под лигу и текстами.
 *
 * Образ к моменту показа уже начислен сервером вместе с остальными наградами
 * матча — модалка ничего не начисляет, только показывает результат.
 */
function RankSkinRewardModal({skinId, onClaim, onEntered}) {
  const [visible, setVisible] = useState(false);
  const enteredRef = useRef(false);

  const {factionId, rank} = parseRankSkinId(skinId);
  const display = RANK_SKIN_DISPLAY[rank];
  const factionName = getFactionConfig(factionId)?.name || factionId;
  const rankColor = RANK_NAME_COLORS[rank];

  useEffect(() => {
    const soundManager = MENU_SOUND_MANAGER;
    if (soundManager?.playFactionSelect && factionId) {
      soundManager.playFactionSelect(factionId, true);
    }

    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [factionId]);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      onClaim?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClaim();
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName !== 'opacity') return;
    if (visible && !enteredRef.current) {
      enteredRef.current = true;
      onEntered?.();
    }
  };

  // Неизвестная лига — показывать нечего (тексты и цвет завязаны на нее)
  if (!display) return null;

  return (
    <div
      className={`faction-skin-reward-overlay rank-skin-reward-overlay ${visible ? 'faction-skin-reward-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      onTransitionEnd={handleTransitionEnd}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`faction-skin-reward-modal rank-skin-reward-modal ${visible ? 'faction-skin-reward-modal_visible' : ''}`}
        style={{'--faction-color': rankColor}}
      >
        <div className="faction-skin-reward-content">
          <div className="faction-skin-reward-image-wrapper">
            <img
              className="faction-skin-reward-image"
              src={getFactionRankImagePath(factionId, rank)}
              alt={`${factionName}: ${display.leagueName}`}
            />
          </div>

          <div className="faction-skin-reward-info">
            <h2 className="faction-skin-reward-name rank-skin-reward-title" style={{color: rankColor}}>
              {`Поздравляем с ${display.rarityFeminine} победой!`}
            </h2>
            <span className="faction-skin-reward-faction rank-skin-reward-text">
              {`Открыт ${display.rarity} образ `}
              <br/>
              <span style={{color: rankColor}}>{`«${factionName}: ${display.leagueName}»`}</span>
            </span>
          </div>

          <div className="main-menu-buttons faction-skin-reward-buttons">
            <PageButton onClick={handleClaim} pageId={PAGE_ID} buttonId="claim_reward">
              Принять дар
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RankSkinRewardModal;
